var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "a",
    { staticClass: "col-sm-6 col-md-4", attrs: { href: _setup.href } },
    [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-header aspect-1-1 p-0" }, [
          _c("picture", [
            _c("source", {
              attrs: {
                srcset: `${_setup.props.product.images[0].src}.webp`,
                type: "image/webp",
              },
            }),
            _c("source", {
              attrs: {
                srcset: `${_setup.props.product.images[0].src}.jpg`,
                type: "image/jpeg",
              },
            }),
            _c("img", {
              attrs: {
                src: `${_setup.props.product.images[0].src}.jpg`,
                alt: `${_setup.props.product.images[0].alt}`,
              },
            }),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "card-body text-center" },
          [
            _c(_setup.BOverlay, { attrs: { show: _setup.loading } }, [
              _c("span", [_vm._v(_vm._s(_setup.props.product.name))]),
              _c("small", [
                _vm._v("For £" + _vm._s(_setup.priceIncrease) + " more each"),
              ]),
            ]),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }